export const Spacing = {
  x0: 0,
  x: 0.4,
  x2: 0.8,
  x3: 1.2,
  x4: 1.6,
  x5: 2,
  x6: 2.4,
  x7: 2.8,
  x8: 3.2,
  x9: 3.6,
  x10: 4,
  x11: 4.4,
  x12: 4.8,
  x14: 5.6,
  x16: 6.4,
  x20: 8,
};
